import type { JSX } from 'react'
import type { IDropdownItemsGroupProps } from '../DropdownItemsGroup'

import { DropdownItemsGroup } from '../DropdownItemsGroup'
import { DropdownItemsGroupPaddings } from '../DropdownItemsGroup.h'

export interface IDropdownItemsGroupLanguageProps extends IDropdownItemsGroupProps {}

export const DropdownItemsGroupLanguage = ({
  height = 320,
  paddings = DropdownItemsGroupPaddings.SIZE_0,
  children,
  ...rest
}: IDropdownItemsGroupLanguageProps): JSX.Element => (
  <DropdownItemsGroup height={height} paddings={paddings} {...rest}>
    {children}
  </DropdownItemsGroup>
)
